export const ageMethod = "age nearest";
export const gateway = "https://one-api.link.wawanesalife.com";
export const assets = "https://stable-assets.link.wawanesalife.com/brokers/one";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJvbmUiLCJuYW1lIjoib25lIiwiaWF0IjoxNzc5OTI1Mjk5LCJleHAiOjE5Mzc3MTMyOTl9.-4Cwvf7PUubvd1ydFueDTI2uUtQuktzmesCknPcie34";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"one.link.wawanesalife.com": {
		a: {
			accessibilityLink: "https://www.oneinsurance.ca/accessibility/",
			approve_company: "CENTRAL",
			approve_user: "link_one",
			brands: [
				"one.link.wawanesalife.com",
			],
			broker: "one",
			broker_formatted_name: "One Insurance",
			email: "life@oneinsurance.ca",
			environment: "stable",
			environment_id: "stable",
			g4: "G-C0WK8RKMH9",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "204-953-2967,1043",
			photos: [
				"photo1.jpg",
				"photo2.jpg",
				"photo3.jpg",
				"photo4.jpg",
			],
			privacyLink: "https://www.oneinsurance.ca/privacy-policy",
			website: "https://www.oneinsurance.ca/",
			scope: "one#branding#one.link.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "one.link.wawanesalife.com",
		},
		b: {
			accessibilityLink: "https://www.oneinsurance.ca/accessibility/",
			approve_company: "CENTRAL",
			approve_user: "link_one",
			brands: [
				"one.link.wawanesalife.com",
			],
			broker: "one",
			broker_formatted_name: "One Insurance",
			email: "life@oneinsurance.ca",
			environment: "stable",
			environment_id: "stable",
			g4: "G-C0WK8RKMH9",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "204-953-2967,1043",
			photos: [
				"photo1.jpg",
				"photo2.jpg",
				"photo3.jpg",
				"photo4.jpg",
			],
			privacyLink: "https://www.oneinsurance.ca/privacy-policy",
			website: "https://www.oneinsurance.ca/",
			scope: "one#branding#one.link.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "one.link.wawanesalife.com",
		},
	},
};

//updated on Wed May 27 2026 18:41:39 GMT-0500 (Central Daylight Time)
